@if(loader){
    <app-loader></app-loader>
    }
<p-card>
    <div class="">
         <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">
            <div>
                <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" (click)="createWarehouse()"
                    size="small" pTooltip="Create {{unitLabel}}"></p-button>
                
                <!-- <p-button *ngIf="selectedwarehouse && selectedwarehouse.length > 0" label="Delete" class="ml-2"
                            icon="pi pi-trash" (click)="deleteWarehouse()" size="small"
                            severity="danger"></p-button> -->
            </div>
            <div class="flex align-items-center ml-3">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                        (keyup.enter)="searchWarehouse()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;"/>
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchWarehouse()" class="ml-2"
                        [ngStyle]="{ height: '35px' }" [raised]="true"
                        [size]="'small'" severity="info"></p-button>
            </div>
            <p-button *ngIf="selectedwarehouse && selectedwarehouse.length == 1" label="Edit" class="ml-2"
                    icon="pi pi-user-edit" (click)="editWarehouse()" size="small" severity="secondary"></p-button>
            </div>
                <h2 class="page-title-center">{{unitLabel}} List</h2>

            <div class="flex">
                <div class="flex align-items-center">
                    <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>
            </div>
        
        </div>


         <p-table #dt1 [value]="result.warehouses" [scrollable]="true" scrollHeight="650px" styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
                [paginator]="true" [rows]="10" [globalFilterFields]="['warehouseCode']" (onPage)="loadwarehouses($event)" [(selection)]="selectedwarehouse"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,15,20]">
                <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>{{unitLabel}} Code</th>
                    <th>{{unitLabel}} Name</th> 
                    <th>Person Name</th>
                    <th>Contact</th>
                    <th>City</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-Warehouse>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="Warehouse"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editWarehouse(Warehouse.warehouseId)">{{Warehouse.warehouseCode}}</td>
                    <td>{{Warehouse.warehouseName}}</td>
                    <td>{{Warehouse.contactName}}</td>
                    <td>{{Warehouse.mobile}}</td>
                    <td>{{Warehouse.address.city}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    </p-card>
    <p-confirmDialog></p-confirmDialog>
